<template>
    <div>
        <p><slot></slot></p>
    </div>
</template>

<script>
    export default {
        name: "LoveMapDescription"
    }
</script>

<style scoped>
    p {
        font-style: italic;
        vertical-align: baseline;
        display: inline-block;
        font-size: 13px;
        color: #333;
    }
</style>